'use client';

import { useRouter } from 'next/navigation';
import { useGlossaries } from 'providers/GlossaryProviders/useGlossaries';
import { useStyleGuides } from 'providers/StyleGuideProviders/useStyleGuides';
import { useTMUHasTermsLanguagePairs } from 'providers/TranslationMemoryProviders/useTMUHasTermsLanguagePairs';
import { useCallback, useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { removeCache } from 'utils/removeCache';

const routes = [
  '/account-details',
  '/account-details/general',
  '/account-details/manage',
  '/account-details/security',
  '/billing',
  '/billing/info',
  '/billing/invoices',
  '/billing/orders',
  '/billing/payments',
  '/billing/transactions',
  '/billing/orders',
  '/content-creator',
  '/content-creator/new',
  '/content-creator/list',
  '/dashboard',
  '/translation/tasks-in-progress',
  '/translation/translation-requests',
  '/translation/new',
  '/translation/show-translation/0',
  '/translation/show-task/0',
  '/glossary',
  '/glossary/new',
  '/glossary/list',
  '/integrations',
  '/integrations/github',
  // '/integrations/hubspot',
  '/integrations/hubspot/cms',
  '/integrations/hubspot/marketing',
  '/integrations',
  // '/organizations',
  '/projects',
  '/style-guides',
  '/smart-tasks/chat-ai',
  '/smart-tasks/context-library',
  '/smart-tasks/context-library/list',
  '/style-guides',
  '/style-guides/new',
  '/style-guides/list',
  '/translation-memory',
  '/translation-memory/list'
];

export default function Prefetch() {
  useTMUHasTermsLanguagePairs({
    page: 1,
    query: '',
    currentLanguagePair: ''
  });
  const router = useRouter();

  useGlossaries();
  useStyleGuides();

  const rePrefetch = useCallback(() => {
    removeCache();
    routes.forEach((route) => router.prefetch(route));
  }, [router]);

  const debouncedMutation = useDebouncedCallback(rePrefetch, 1000);

  useEffect(() => {
    debouncedMutation();
  }, [debouncedMutation]);

  return null;
}
